module.exports = __webpack_public_path__ + "img/person.485d3ce4.png";